import { lazy, Suspense, useState, useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import './App.css';

import { QueryProvider } from './config/query';
import { AuthProvider, ThemeProvider, PerformanceProvider, SidebarBehaviorProvider, KeyboardShortcutsProvider } from './contexts';
import { useAppRouter } from './routes';
import { ToastProvider } from './components/Toast';
import { AuthValidator } from './components/Auth';
import { SequenceIndicator } from './components/KeyboardShortcuts';

// Lazy load do EasterEggListener - só carrega quando necessário
const EasterEggListener = lazy(() => 
  import('./components/EasterEgg').then(module => ({ default: module.EasterEggListener }))
);

export const App = () => {
  const router = useAppRouter();
  const [mountEasterEgg, setMountEasterEgg] = useState(false);

  // Monta o EasterEggListener após o app estar carregado para não impactar performance inicial
  useEffect(() => {
    const timer = setTimeout(() => {
      setMountEasterEgg(true);
    }, 30000); // Delay de 30 segundos
    return () => clearTimeout(timer);
  }, []);

  return (
    <ThemeProvider>
      <PerformanceProvider>
        <SidebarBehaviorProvider>
          <KeyboardShortcutsProvider>
            <QueryProvider>
              <AuthProvider>
                <AuthValidator />
                <SequenceIndicator />
                {mountEasterEgg && (
                  <Suspense fallback={null}>
                    <EasterEggListener />
                  </Suspense>
                )}
                <ToastProvider position="top-right">
                  <RouterProvider router={router} />
                </ToastProvider>
              </AuthProvider>
            </QueryProvider>
          </KeyboardShortcutsProvider>
        </SidebarBehaviorProvider>
      </PerformanceProvider>
    </ThemeProvider>
  );
};

export default App;
